/**
 * Gatsby Browser APIs and styles
 * Read more at https://www.gatsbyjs.org/docs/browser-apis/
 */

// Bootstrap
// import 'bootstrap/dist/css/bootstrap.min.css';

// Bootstrap Dark 5 - https://github.com/vinorodrigues/bootstrap-dark-5
// Add "dark" class attribute to html element (using React Helmet) to switch to dark mode
// import 'bootstrap-dark-5/dist/css/bootstrap-nightshade.min.css';

// Custom styles, if provided
import './src/styles/styles.scss';

// Prompt for PWA reloading (if enabled)
const onServiceWorkerUpdateReadyFunction = (_apiCallbackContext) => {
  window.location.reload();
};

export const onServiceWorkerUpdateReady = onServiceWorkerUpdateReadyFunction;
